import videosService from '@/services/videos'

export default {
  namespaced: true,

  state: {
    contactLink: '',
    videosAction: '',
    videosList: [],
    video: null,
    showFilter: false,
    speakersFilters: [],
    tagsFilters: [],
    selectedSpeakers: [],
    selectedTags: [],
    query: '',
    showVideoAuthModal: false,
  },

  mutations: {
    setContactLink(state, link) {
      state.contactLink = link
    },

    setVideosAction(state, action) {
      state.videosAction = action
    },

    setVideosList(state, list) {
      state.videosList = list
    },

    setVideo(state, video) {
      state.video = video
    },

    setShowFilter(state, status) {
      state.showFilter = status
    },

    setSpeakersFilters(state, list) {
      state.speakersFilters = list
    },

    setTagsFilters(state, list) {
      state.tagsFilters = list
    },

    setSelectedFilter(state, { prop, item }) {
      if (state[prop].includes(item)) {
        const idx = state[prop].findIndex(elem => elem === item)
        state[prop].splice(idx, 1)
      } else {
        state[prop].push(item)
      }
    },

    clearFilters(state) {
      state.selectedSpeakers = []
      state.selectedTags = []
    },

    updateQuery(state, query) {
      state.query = query
    },

    setShowVideoAuthModal(state, status) {
      state.showVideoAuthModal = status
    },

    updateVideoFavorite(state, { pk, status }) {
      const video = state.videosList.find(video => video.pk === pk)
      video.is_favorite = status
    },
  },

  actions: {
    async fetchContactLink({ commit }) {
      const res = await videosService.getVideoContactLink()
      if (res.response && res.response.status === 404) {
        commit('setContactLink', '')
      } else {
        commit('setContactLink', res)
      }
    },

    fetchListBase({ state, commit }, { slug, service }) {
      let payload = ''
      let params = {}
      if (state.selectedSpeakers.length)
        params.speakers = state.selectedSpeakers.join()
      if (state.selectedTags.length) params.tags = state.selectedTags.join()
      if (state.query) params.query = state.query

      // Check if params is not an empty object to include payload
      if (
        !(Object.keys(params).length === 0 && params.constructor === Object)
      ) {
        payload = {
          params,
        }
      }

      return new Promise(resolve => {
        videosService[service](slug, payload).then(res => {
          commit('setVideosList', res)
          resolve(res)
        })
      })
    },

    fetchVideosList({ dispatch }, { slug }) {
      dispatch('fetchListBase', { slug, service: 'getVideosList' })
    },

    fetchDemosList({ dispatch }, { slug }) {
      dispatch('fetchListBase', { slug, service: 'getDemosList' })
    },

    fetchFeaturedVideos({ commit }) {
      videosService.getFeaturedVideos().then(res => {
        commit('setVideosList', res)
      })
    },

    fetchVideosUserHistory({ commit }) {
      videosService.getVideosUserHistory().then(res => {
        commit('setVideosList', res)
      })
    },

    fetchVideo({ commit }, slug) {
      return new Promise(resolve => {
        videosService.getVideo(slug).then(res => {
          // if (res.response) {
          //   if (res.response.status === 404) {
          //     commit('setError404', true, { root: true })
          //   }
          // } else {
          //   if (!res.available) {
          //     commit('setError404', true, { root: true })
          //   } else {
          //     commit('setVideo', res)
          //     resolve(res)
          //   }
          // }
          commit('setVideo', res)
          resolve(res)
        })
      })
    },

    fetchVideosFilters({ commit }, slug) {
      videosService.getVideosFilters(slug).then(res => {
        commit('setTagsFilters', res)
      })
    },

    setSelectedSpeaker({ commit }, speaker) {
      commit('setSelectedFilter', { prop: 'selectedSpeakers', item: speaker })
    },

    setSelectedTag({ commit }, tag) {
      commit('setSelectedFilter', { prop: 'selectedTags', item: tag })
    },

    sendInteractionData(context, payload) {
      return new Promise(resolve => {
        videosService.createInteraction(payload)
        resolve()
      })
    },

    sendViewingData(context, payload) {
      videosService.createViewing(payload)
    },
  },
}
